import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=0023df9a&scoped=true"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"
import style0 from "./Save.vue?vue&type=style&index=0&id=0023df9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023df9a",
  null
  
)

export default component.exports